import React, { useEffect, useState, useContext } from 'react';
import Header from '../Header/AppHeader';
import Axiosfetch from '../Common/Axiosfetch';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../QuotationsApproval/QApprovalStyle.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faRupeeSign, faSearch } from '@fortawesome/free-solid-svg-icons';
import moment from 'moment';
import Alert from 'react-s-alert';
import 'react-s-alert/dist/s-alert-default.css';
import 'react-s-alert/dist/s-alert-css-effects/slide.css';
import baseURL from '../Common/Config';
import { ThemeContext } from '../Common/ThemeProvider';
import FailureAlert from '../Common/Failure';
import Regions from '../Common/Region';

const QApproval = () => {
    const { CurrentTheme } = useContext(ThemeContext);
    // eslint-disable-next-line
    const [companyInfo, setCompanyInfo] = useState([]);
    const [QuotationData, setQuotationData] = useState([]);
    const [SelectedQuotationInfo, setSelectedQuotationInfo] = useState([]);
    const [displayValue, setDisplayValue] = useState("none");
    const [SelectedQuotationID, setSelectedQuotationID] = useState(0);
    const [SelectedReason, setSelectedReason] = useState("");
    const [RegionSymbol, setRegionSymbol] = useState({});
    const [FilterQuotation, setFilterQuotation] = useState([]);

    useEffect(() => {
        FetchQuotationByStatus();

        if (localStorage.getItem("CompanyInfo") !== null) {
            var companyDetails = JSON.parse(localStorage.getItem("CompanyInfo"));
            setCompanyInfo(companyDetails);
            var region = Regions.filter(r => r.Code === companyDetails.CountryCode);
            if (region.length > 0) {
                setRegionSymbol(region[0]);
            }
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const QuotationDataSuccess = (data) => {
        if (data.length > 0) {
            setQuotationData(data);
            setFilterQuotation(data);
        }
        else {
            setQuotationData([]);
            setFilterQuotation([]);
        }
    };

    const Failure = (err) => {
        FailureAlert(err);
    };

    const UpdateQuotationSuccess = (data) => {
        setDisplayValue("none");
        Axiosfetch(baseURL + "GetAllQuotationsByStatus", "POST", { Status: 1 }, QuotationDataSuccess, Failure);
        if (data === "approved") {
            Alert.success("Quotation Approved.", {
                position: 'bottom-right',
                effect: 'slide',
                html: false
            });
        }
        else {
            Alert.success("Quotation Rejected.", {
                position: 'bottom-right',
                effect: 'slide',
                html: false
            });
        }
    };

    const onRejectQuotation = (QuotationID) => {
        if (SelectedReason.trim() === "") {
            Alert.error("Please Select a Reason for Rejection.", {
                position: 'bottom-right',
                effect: 'slide',
                html: false
            });
        }
        else {
            Axiosfetch(baseURL + "ChangeQuotationStatus", "POST", { ID: QuotationID, Status: 3, Reason: SelectedReason }, UpdateQuotationSuccess, Failure);
        }
    };

    const onAcceptQuotation = (QuotationID) => {
        Axiosfetch(baseURL + "ChangeQuotationStatus", "POST", { ID: QuotationID, Status: 2, Reason: null }, UpdateQuotationSuccess, Failure);
    };

    const getQuotationInfo = (QuotationID) => {
        setSelectedQuotationID(QuotationID);
        Axiosfetch(baseURL + "getQuotationInfo", "POST", { ID: QuotationID }, SelectedQuotationInfoSuccess, Failure);
    };

    const SelectedQuotationInfoSuccess = (data) => {
        if (data.length > 0) {
            setDisplayValue("block");
            setSelectedQuotationInfo(data);
        }
        else {
            Alert.warning("No Product Information found.", {
                position: 'bottom-right',
                effect: 'slide',
                html: false
            });
        }
    };

    const hideProductInfo = () => {
        setDisplayValue("none");
    };

    const onQuotationSearch = (e) => {
        let searchValue = e.target.value;
        if (searchValue !== "") {
            let quotationSearchData = QuotationData.filter(c => c.Customer.Name.toLowerCase().includes(searchValue.trim().toLowerCase()));
            setFilterQuotation(quotationSearchData);
        }
        else {
            setFilterQuotation(QuotationData);
        }
    };

    const FetchQuotationByStatus = () => {
        Axiosfetch(baseURL + "GetAllQuotationsByStatus", "POST", { Status: 1 }, QuotationDataSuccess, Failure);
    };

    return (
        <div>
            <Header></Header>
            <div className="container-fluid InvoiceTheme sidemenu-show">
                <div className="row">
                    <div className="offset-md-3 col-md-6 col-sm-6">
                        <h5 className="align-center" style={{ fontWeight: "500" }}>Manage Quotations</h5>
                    </div>
                    <div className="col-md-3 col-sm-3" style={{ display: "flex" }}>
                        <input type="text" name="Name" placeholder="Search By Customer..."
                            className="form-control" style={{ marginRight: "10px", borderRadius: "20px", paddingLeft: "40px" }}
                            onChange={e => onQuotationSearch(e)}></input>
                        <div className={`${CurrentTheme}Color`} style={{ fontSize: "1rem", position: "absolute", left: "9%", top: "17%" }}>
                            <FontAwesomeIcon icon={faSearch} />
                        </div>
                    </div>
                </div>
                <div className="PageHeight" style={{ scrollbarColor: "#005582 transparent" }}>
                    <div className="row">
                        {
                            FilterQuotation.length > 0 && FilterQuotation.map(quotation => (
                                <div className="col-md-3 col-xs-12 col-sm-12" key={quotation.ID} style={{ marginBottom: "15px" }}>
                                    <div className="card cardMargin nonSelectable cursor CardhoverStyle align-center" onClick={(QuotationID) => getQuotationInfo(quotation.ID)}>
                                        <div className="card-header" title={moment(quotation.ValidDate) > moment(new Date()) ? "Valid Quotation" : "Validity Expired"}>
                                            <div> Quote/{quotation.Customer ? quotation.Customer.Name.split(' ')[0].trim() : ""}/#{quotation.ID}/{moment(quotation.CreatedDate).local().format("DDMMYYYY")}</div>
                                            {moment(quotation.ValidDate) < moment(new Date()) && (<div style={{
                                                position: "absolute", left: "95%", top: "-7px", backgroundColor: "#ff4c4c",
                                                width: "30px", borderRadius: "20px", color: "white", height: "30px", border: "2px solid white"
                                            }}>!</div>)}
                                        </div>
                                        <div className="card-body">
                                            <h5 style={{ paddingBottom: "3px" }} className="card-title ellipseStyle" title={quotation.Customer.Name}>{quotation.Customer.Name}</h5>
                                            <div className="row">
                                                <div className="col-md-12 col-sm-12">
                                                    <ul className="list-group list-group-flush">
                                                        <li className="list-group-item liStyle">
                                                            <div className="row">
                                                                <div className="col-md-6 col-sm-6">
                                                                    <b>Quantity</b>
                                                                </div>
                                                                <div className="col-md-6 col-sm-6">
                                                                    <span className="font-size13rem">{quotation.TotalQuantity}</span>
                                                                </div>
                                                            </div>
                                                        </li>
                                                        <li style={{ paddingTop: ".35rem" }} className="list-group-item liStyle">
                                                            <div className="row">
                                                                <div className="col-md-6  col-sm-6">
                                                                    <b>Amount</b>
                                                                </div>
                                                                <div className="col-md-6  col-sm-6">
                                                                    <FontAwesomeIcon className="font-size13rem" icon={faRupeeSign}></FontAwesomeIcon>
                                                                    <span className="font-size13rem"> {quotation.TotalAmount}</span>
                                                                </div>
                                                            </div>
                                                        </li>
                                                        <li className="list-group-item">
                                                            <div className="row" style={{ fontSize: "14px" }}>
                                                                <div className="col-md-6  col-sm-6 borderDateStyle">
                                                                    {moment(quotation.CreatedDate).format('DD MMM YYYY, h:mm:ss A')}
                                                                </div>
                                                                <div className="col-md-6  col-sm-6">
                                                                    {moment(quotation.ValidDate).format('DD MMM YYYY, h:mm:ss A')}
                                                                </div>
                                                            </div>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>

                            ))

                        }
                        {
                            FilterQuotation.length === 0 ? (
                                <div className="col-md-12 col-sm-12 align-center">
                                    <h5 className="align-center" style={{ fontWeight: "400", marginBottom: "15px", position: "absolute", left: "32vw", top: "20vh" }}>There are No Quotation to Approve Or Reject.</h5>
                                </div>
                            ) : ""
                        }

                    </div>

                </div>
                <div id="myModalProductInfo" className="modal" style={{ display: displayValue }}>
                    <div className="modal-content">
                        <div className={`modal-header header-style align-center ${CurrentTheme}`}>
                            <span style={{ marginLeft: "5px", padding: "5px" }}>Product Information</span>
                            <span className="close" onClick={hideProductInfo}>&times;</span>
                        </div>
                        <div className="ProductInfoHeightStyle">
                            <table className="table table-striped">
                                <thead>
                                    <tr>
                                        <th className={`align-center InvoicetitleStyle ${CurrentTheme}`}>Product</th>
                                        <th className={`align-center InvoicetitleStyle ${CurrentTheme}`}>{RegionSymbol.TaxSystem !== undefined ? RegionSymbol.TaxSystem : "GST"} (%)</th>
                                        <th className={`align-center InvoicetitleStyle ${CurrentTheme}`}>Quantity</th>
                                        <th className={`align-center InvoicetitleStyle ${CurrentTheme}`}>Units</th>
                                        <th className={`align-center InvoicetitleStyle ${CurrentTheme}`}>Price</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {SelectedQuotationInfo.length > 0 && SelectedQuotationInfo.map(QInfo => (
                                        <tr key={QInfo.ID}>
                                            <td className="align-center">{QInfo.Product.Name}</td>
                                            <td className="align-center">{QInfo.ProductGST}</td>
                                            <td className="align-center">{QInfo.ProductQuantity}</td>
                                            <td className="align-center">{QInfo.Product.Units}</td>
                                            <td className="align-center">{QInfo.ProductPrice}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                        <div className="row" style={{ marginTop: "5px" }}>
                            <div className="col-md-2">
                                <h5>Reason</h5>
                            </div>
                            <div className="col-md-10">
                                <textarea rows="1" className="form-control" style={{ width: "100%" }} onChange={(e) => setSelectedReason(e.target.value)}></textarea>
                            </div>
                        </div>
                        <div className="row" style={{ marginTop: "15px" }}>
                            <div className="col-md-12 text-right">
                                <button type="button" className="btn btn-Save" onClick={(QuotationID) => onAcceptQuotation(SelectedQuotationID)}>Approve</button>
                                <button type="button" className="btn btn-Reject" onClick={(QuotationID) => onRejectQuotation(SelectedQuotationID)}>Reject</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default QApproval;